function modalCtaAction() {
  const owdModal = document.querySelector('.owd-cta-modal');
  const appDlButtons = document.querySelectorAll('.owd-cta');
  const closeButton = owdModal.querySelector('.owd-cta-modal-close');

  if (!owdModal) {
    return;
  }
  if (window.innerWidth > 430) {
    if (appDlButtons.length > 0) {
      appDlButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          owdModal.classList.add("is-show");
          document.body.style.overflow = 'hidden'; //モーダル表示中はスクロール禁止
          const pageTopButton = document.querySelector(".owd-button-pagetop-wrap");
          pageTopButton ? pageTopButton.style.display = "none" : null;
        });
      });
    }
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        owdModal.classList.remove("is-show");
        document.body.style.overflow = ''; // モーダルを閉じたらスクロールを許可
        const pageTopButton = document.querySelector(".owd-button-pagetop-wrap")
        pageTopButton ? pageTopButton.style.display = "block" : null
      });
    };
    // モーダルの背景部分をクリックしたら閉じる処理
    owdModal.addEventListener('click', (e) => {
      if (e.target === owdModal) {
        owdModal.classList.remove('is-show');
        document.body.style.overflow = '';
        const pageTopButton = document.querySelector(".owd-button-pagetop-wrap")
        pageTopButton ? pageTopButton.style.display = "block" : null
      }
    });
  }
}

export {modalCtaAction}
